module.exports = __webpack_public_path__ + "static/media/c46b50c9-af8a-4310-aafc-030da9ff8d11.b68398c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/competence/c46b50c9-af8a-4310-aafc-030da9ff8d11.png
// module id = 1464
// module chunks = 0